var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"header"},[_c('my-header')],1),_c('main-body',{staticClass:"body"}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('a',{staticClass:"icp",attrs:{"target":"_blank","href":"https://beian.miit.gov.cn/"}},[_vm._v("苏ICP备2025193849号")])])
}]

export { render, staticRenderFns }